import _ from 'lodash';
// import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core';
import CameraIcon from '@material-ui/icons/CameraAlt';

import AuthUserContainer from '../../../../../containers/AuthUser';
import ResourceContainer from '../../../../../containers/Resource';
import Transition from '../../../../../components/dialogs/Transition';
import { Scanner } from './scanner';
import { GeniusScanner } from './GeniusScanner';
import { generalStyles } from '../../util';
import { dialogStyles } from '../dialogStyles';
import MobileDeliveryDialogSavePopup from '../MobileDeliveryDialogSavePopup';
import MobileSaveScanDialog from './MobileSaveScanDialog';

const styles = () => {
	return {
		...generalStyles,
		...dialogStyles,
		dialogSubmitButton: {
			...dialogStyles.dialogSubmitButton,
			marginTop: 0,
			minWidth: '30%',
		},
		dialogRedoButton: {
			...dialogStyles.dialogSecondaryButton,
			marginTop: 0,
			minWidth: '30%',
		},
		dialogCloseButton: {
			...dialogStyles.dialogCloseButton,
			marginTop: 0,
			minWidth: '30%',
		},
	};
};

class MobileScannerDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			savePhoto: false,
			isSaving: false,
			isSaveDialogOpen: false,
		};
	}

	componentDidMount() {}

	handleClose = () => {
		this.props.onClose();
		this.closeSaveDialog();
	};
	setSavePhoto = (val) => {
		this.setState({ savePhoto: val, isSaving: true });
	};
	setJpegForUpload = (jpegForUpload) => {
		this.setState({ jpegForUpload });
		setTimeout(() => {
			this.setState({ isSaveDialogOpen: true, isSaving: false });
		}, 500);
	};

	openSaveDialog = () => {
		this.setState({
			isSaveDialogOpen: true,
		});
	};
	closeSaveDialog = () => {
		this.setState({
			isSaveDialogOpen: false,
		});
	};

	render() {
		const { open, classes, permissionMap } = this.props;
		const { isSaving, hasSavingSuccess, hasSavingError, savingError } = this.state;
		const canBetaGeniusScan = permissionMap ? permissionMap.canBetaGeniusScan : false;
		const hideRetake = canBetaGeniusScan;

		return (
			<>
				<Dialog
					open={open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
					fullWidth={true}
					fullScreen={true}
					maxWidth={'lg'}
					classes={{ scrollPaper: classes.dialogRoot }}
				>
					<DialogContent
						dividers={true}
						style={{
							position: 'relative',
							padding: 0,
							border: 0,
							height: '100%',
							overflow: 'hidden',
							opacity: isSaving ? 0.5 : 1,
						}}
					>
						{canBetaGeniusScan ? (
							<GeniusScanner
								savePhoto={this.state.savePhoto}
								setSavePhoto={this.setSavePhoto}
								setJpegForUpload={this.setJpegForUpload}
								onClose={this.handleClose}
							/>
						) : (
							<Scanner
								savePhoto={this.state.savePhoto}
								setSavePhoto={this.setSavePhoto}
								setJpegForUpload={this.setJpegForUpload}
							/>
						)}
					</DialogContent>

					<DialogActions style={{ position: 'relative', backgroundColor: '#f7f7f7' }}>
						<MobileDeliveryDialogSavePopup
							classes={classes}
							hasSavingSuccess={hasSavingSuccess}
							hasSavingError={hasSavingError}
							savingError={savingError}
							savingSuccess={'Upload successful. Click close.'}
						/>

						<div style={{ display: 'flex', width: '100%', padding: '0px 2vw' }}>
							<Button
								variant="contained"
								color="primary"
								aria-label="submitRackDelay"
								className={classes.dialogSubmitButton}
								onClick={() => {
									this.setSavePhoto(true);
								}}
								disabled={isSaving}
							>
								<CameraIcon style={{ paddingRight: 5 }} />
								Scan
							</Button>

							<Button
								variant="outlined"
								className={classes.dialogCloseButton}
								onClick={this.handleClose}
								disabled={isSaving}
							>
								Close
							</Button>
						</div>
					</DialogActions>
				</Dialog>

				<MobileSaveScanDialog
					open={this.state.isSaveDialogOpen}
					onClose={this.closeSaveDialog}
					onCloseAllDialogs={this.handleClose}
					jpegForUpload={this.state.jpegForUpload}
					setBolResource={this.props.setBolResource}
					hideRetake={hideRetake}
				/>
			</>
		);
	}
}

MobileScannerDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	onRetake: PropTypes.func,
	classes: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	addResource: PropTypes.func.isRequired,
	setBolResource: PropTypes.func.isRequired,
};
export default _.flow([withStyles(styles), AuthUserContainer, ResourceContainer])(
	MobileScannerDialog
);
